// TODO enable eslint
/* eslint-disable no-param-reassign */
import omit from "lodash/omit"
import { Model, Schema } from "src/engine/modules/model/classes"
import moment from "moment"

const entityName = `plan`

const denormalizePlan = data => {
  /* remove sec and msec from date for back */
  if (data.endDateTime) {
    data.endDateTime = moment(data.endDateTime)
      .startOf(`minute`)
      .valueOf()
  }
  if (data.startDateTime) {
    data.startDateTime = moment(data.startDateTime)
      .startOf(`minute`)
      .valueOf()
  }
  return omit(data, [`id`])
}

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `/plans/${id}` : `plans`),
  primaryKey: `id`,
  denormalize: denormalizePlan,
  schema: new Schema({
    startDateTime: new Schema.types.DateTime(`ms`),
    endDateTime: new Schema.types.DateTime(`ms`),
    accessibleResources: new Schema.types.Any(),
  }),
})
